/* eslint-disable no-unused-expressions */
import baseUrls from './baseUrls';

const parseJson = rawResponse =>
  new Promise((resolve, reject) => {
    try {
      resolve(rawResponse.json());
    } catch (e) {
      // The consumer should catch and handle gracefully or rethrow to hit error boundary
      reject(e);
    }
  });

const logError = () => {
  // console.error(error);
}; // some logging would be nice

const errorHandler = error => {
  logError(error);
  // The consumer should catch and handle gracefully or rethrow to hit error boundary
  throw new Error(error);
};

const handleResponse = async rawResponse => {
  if (rawResponse) {
    const jsonResponse = await parseJson(rawResponse);
    return jsonResponse;
  }
  return {
    success: rawResponse.ok,
    status: rawResponse.status
  };
};

const generateQueryString = query => {
  if (!query) {
    return '';
  }
  let builtQuery = '';
  query.forEach(q => {
    builtQuery += `&${q.key}=${q.value}`;
  });
  return builtQuery;
};

const generateUrl = ({ pre, endpoint, aft, query, baseUrl }) => {
  let url = '';

  url += `${baseUrls[baseUrl].url}/`;

  pre && (url += `${pre}/`);

  endpoint && (url += `${baseUrls[baseUrl].endpoints[endpoint]}/`);

  aft && (url += `${aft}/`);

  query && (url += generateQueryString(query));

  return url;
};

/* global _config  fetch  Headers */
const httpClient = {
  /** pre, endpoint, aft, params, baseUrl */
  get: input =>
    fetch(generateUrl(input))
      .then(rawResponse => handleResponse(rawResponse))
      .catch(e => errorHandler(e)),
  /** */
  post: ({ endpoint, params, baseUrl }) =>
    fetch(
      `${baseUrls[baseUrl].url}/${
        baseUrls[baseUrl].endpoints[endpoint]
      }?token=${_config.token}`,
      {
        headers: new Headers({ 'content-type': 'application/json' }),
        ...(params.body && { body: JSON.stringify(params.body) })
      }
    )
      .then(rawResponse => handleResponse(rawResponse))
      .catch(e => errorHandler(e))
};

Object.freeze(httpClient);

export default httpClient;
